import React from "react";
import { Col, Row } from "reactstrap";
import { Dropdown } from "primereact/dropdown";
import countryData from "../../Country/country.json";
import { useTranslation } from "react-i18next";

const UserProfilePhone = ({
  fieldLabel = "Phone",
  placeholderArea,
  placeholderPhone,
  valueArea,
  valuePhone,
  onChangeArea,
  onChangePhone,
}) => {
  const { t } = useTranslation();
  const selectedCountry = countryData.find(
    (c) => valueArea && c.code.toLowerCase() === valueArea.toLowerCase()
  );

  const areaCodeTemplate = (option, props) => {
    if (option) {
      return (
        <div className="d-flex align-items-center">
          <img
            src={option.flag}
            alt={option.name}
            style={{ width: "24px", marginRight: "10px" }}
          />
          +{option.areaCode}
        </div>
      );
    }
    return <span>{props.placeholder}</span>;
  };

  const itemTemplate = (option) => (
    <div className="d-flex align-items-center">
      <img
        src={option.flag}
        alt={option.name}
        style={{ width: "24px", marginRight: "10px" }}
      />
      +{option.areaCode} ({t(`${option.code}.country.label`)})
    </div>
  );

  return (
    <div className="form-group col-xl-12">
      <label className="form-label">{fieldLabel}</label>
      <Row className="align-items-center">
        <Col xs={5}>
          <Dropdown
            value={selectedCountry}
            options={countryData.filter((c) => c.areaCode)}
            onChange={(e) => onChangeArea({ target: { value: e.value.code } })}
            optionLabel="areaCode"
            placeholder={t("select.label")}
            className="w-100"
            valueTemplate={areaCodeTemplate}
            itemTemplate={itemTemplate}
          />
        </Col>
        <Col xs={7}>
          <input
            type="text"
            className="form-control"
            placeholder={placeholderPhone}
            value={valuePhone}
            onChange={onChangePhone}
            name="phoneNumber"
          />
        </Col>
      </Row>
    </div>
  );
};

export default UserProfilePhone;
